import { Component } from '@angular/core';
import { ChartComponent } from '../charts/chart.component';
import { FilteredReport } from '../filtered-report';
import { FiltersComponent } from '../filters/filters.component';
import { AttritionData } from '../workforce.types';
import { ATTRITION_SERIES } from '../report-presentation';

@Component({ selector: 'app-attrition', standalone: false, templateUrl: './attrition.component.html' })
export class AttritionComponent extends FilteredReport<AttritionData> {
  protected readonly endpoint = '/workforce/attrition-trends';
  protected readonly fallbackError = 'Unable to load attrition data. Please retry.';
  readonly series = ATTRITION_SERIES;
  get groupLabel(): string { return this.groupBy.charAt(0).toUpperCase() + this.groupBy.slice(1); }
  get groupPlural(): string { return { department: 'departments', business: 'businesses', company: 'companies' }[this.groupBy]; }
  bandClass(band: string | null): string { return band === 'High' ? 'band-high' : band === 'Medium' ? 'band-medium' : band ? 'band-low' : ''; }
}
